import { Icon } from "Components";

const WhiteListing = () => <div className="pm-info-banner">
    <div className="pm-info-content">
        <div className="pm-info-row">
            <div className="pm-info-icon-wrapper">
                <div className="pm-info-icon">
                    <Icon type="campaignInfo" />
                </div>
            </div>

            <div className="pm-info-text-group">
                <div className="pm-info-title">
                    Configure Whitelisting for Successful Campaigns
                </div>
                <div className="pm-info-description">
                    To ensure phishing simulations are delivered, clients must whitelist
                    Venza’s email infrastructure. This step allows campaigns to be
                    accessible and prevents client-side security controls from blocking
                    email delivery.
                </div>
            </div>
        </div>
    </div>

    <div className="pm-info-action">
        <a
            href="https://www.venzapeak.com/support/public_resources/phishing/whitelist/#/"
            target="_blank"
            rel="noopener noreferrer"
            className="pm-info-action-text"
        >
            View Whitelisting Guide
        </a>
    </div>

</div>

export default WhiteListing;